<template>
    <imports-list
        :context="getContext()"
        importType="contact"
        newImportHref="/contacts/import/new"
        v-model:showOverview="showOverview"
    >
        <template v-slot:title>Contact Imports</template>
        <template v-slot:overview>
            <contacts-import-overview v-show="showOverview" class="mb-14"></contacts-import-overview>
        </template>
    </imports-list>
</template>

<script setup>
import ImportsList from '~/components/import/ImportsList.vue';
import ContactsImportOverview from '~/components/contacts/import/ContactsImportOverview.vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import { ref } from 'vue';

const { getContext } = useCurrentGroup();
const showOverview = ref(true);
</script>
